import { Typography } from "@mui/material"
import { useState } from "react"
import { extraColors } from "../../../../utils/theme"
import { SettingsContainer } from "../../shared/SettingsContainer"
import { useNotificationContext } from "../contexts/NotificationContext"
import { EmailExampleDialog } from "../EmailExampleDialog"
import { SettingCheckbox } from "../SettingCheckbox"
import { Alerts } from "./Alerts/Alerts"

export const ExpertInsights = () => {
  const { analysisEnabled, setAnalysisEnabled } = useNotificationContext()
  const [dialogIsOpen, setDialogIsOpen] = useState(false)

  return (
    <SettingsContainer title="Expert Insights">
      <Typography variant="body1">
        Receive emails for the following content when there is information on
        any potential threats.{" "}
        <Typography
          variant="body1Bold"
          onClick={() => setDialogIsOpen(true)}
          sx={{ cursor: "pointer", color: extraColors.status.navyLight }}
        >
          View examples
        </Typography>
      </Typography>
      <EmailExampleDialog
        dialogIsOpen={dialogIsOpen}
        setDialogIsOpen={setDialogIsOpen}
      />
      <Alerts />
      <SettingCheckbox
        settingEnabled={analysisEnabled || false}
        setSettingEnabled={setAnalysisEnabled}
        title="Analysis"
      />
    </SettingsContainer>
  )
}
